import Table, { TableActions } from 'components/Table';
import {
  numberToCurrencyString,
  renderMultiple,
  numberToDisplayString,
} from 'further-ui/utils';
import useTopAdvisers from 'hooks/data/dashboards/useTopAdvisers';
import { Link } from 'react-router-dom';
import { ADVISER, createAdviserViewRoute } from 'adminConstants/routes';
import topAdviserTableStyles from './styles';
import { Tooltip } from '@mui/material';
import { InfoOutlined, Visibility } from '@mui/icons-material';
import LoadingError from '../LoadingError';

const TopAdviserTable = ({ firmId, height }) => {
  const {
    data: advisers,
    isFetching,
    isRefetching,
    isError,
  } = useTopAdvisers({
    params: { firmId },
  });

  const isLoading = isFetching || isRefetching;
  const { classes } = topAdviserTableStyles();
  const columns = [
    {
      label: 'Name',
      key: 'fullName',
      sort: false,
    },
    {
      label: 'Subscription amount',
      key: 'totalInvestmentAmount',
      render: (adviser) =>
        numberToCurrencyString(adviser.totalInvestmentAmount),
      sort: false,
    },
    {
      label: 'Current value AUM',
      key: 'currentValueAum',
      render: (adviser) => numberToCurrencyString(adviser.currentValueAum),
      sort: false,
    },
    {
      label: 'Total portfolio value',
      key: 'totalPortfolioValue',
      render: (adviser) => numberToCurrencyString(adviser.totalPortfolioValue),
      sort: false,
    },
    {
      label: (
        <div className={classes.tooltipContainer}>
          Blended multiple{' '}
          <Tooltip title="This is the live multiple on investment across all subscriptions linked to this adviser. The multiple considers only paid-up funds and does not include unpaid but committed capital.">
            <InfoOutlined className={classes.tooltipIcon} />
          </Tooltip>
        </div>
      ),
      key: 'blendedMultiple',
      render: (adviser) => renderMultiple(adviser.blendedMultiple),
      sort: false,
    },
    {
      label: 'Subscriptions',
      key: 'totalInvestments',
      render: (adviser) => numberToDisplayString(adviser.totalInvestments),
      sort: false,
    },
    {
      label: 'Clients',
      key: 'investorCount',
      render: (adviser) => numberToDisplayString(adviser.investorCount),
      sort: false,
    },
    {
      label: '',
      key: 'actions',
      render: (adviser) => (
        <TableActions
          actions={[
            {
              link: createAdviserViewRoute(adviser._id),
              icon: Visibility,
              label: 'View',
              color: 'primary',
            },
          ]}
        />
      ),
      sort: false,
    },
  ];

  if (isError) {
    return <LoadingError height={height} showCard={false} />;
  }

  return (
    <>
      <Link className={classes.link} to={ADVISER}>
        View all
      </Link>
      <Table
        columns={columns}
        tablebody={advisers ?? []}
        pagination={false}
        variant="nohover"
        loading={isLoading}
        rowsPerPage={10}
        emptyMessage="No advisers found."
      />
    </>
  );
};

export default TopAdviserTable;
